import { render, staticRenderFns } from "./RatificacionFirmasInfo.vue?vue&type=template&id=642c2458"
import script from "./RatificacionFirmasInfo.vue?vue&type=script&lang=js"
export * from "./RatificacionFirmasInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('642c2458')) {
      api.createRecord('642c2458', component.options)
    } else {
      api.reload('642c2458', component.options)
    }
    module.hot.accept("./RatificacionFirmasInfo.vue?vue&type=template&id=642c2458", function () {
      api.rerender('642c2458', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/info_procesos/RatificacionFirmasInfo.vue"
export default component.exports